import React, { useState } from "react";
import PageBreadcrumb from "../../components/common/CustomBreadCrumb";
import ComponentCard from "../../components/common/ComponentCard";
import LeaderboardTable from "../../components/tables/LeaderboardTable";
import PageMeta from "../../components/common/PageMeta";
import Input from "../../components/form/input/InputField";
import { Search } from "lucide-react";
import { useLeaderboard } from "@/hooks/useLeaderboard";
import { useTranslation } from "react-i18next";

export default function ListLeaderboard() {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const { t } = useTranslation();

    const { data, isLoading, isError } = useLeaderboard(currentPage, searchQuery);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <PageMeta
                title="VIYUME - VIYUME Dashboard"
                description="Leaderboard Management"
            />
            <div className="space-y-6">
                <ComponentCard title="">
                    <div className="mb-4 relative">
                        <Input
                            type="text"
                            placeholder={t("Search Leaderboard")}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="pl-10"
                        />
                        <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    </div>
                    {isLoading ? (
                        <div className="animate-pulse">
                            <div className="space-y-4">
                                {[...Array(5)].map((_, index) => (
                                    <div key={index} className="flex items-center space-x-4 py-3">
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : isError ? (
                        <div className="text-red-500 text-center p-4">Failed to fetch leaderboards.</div>
                    ) : (
                        <LeaderboardTable
                            leaderboards={data?.data || []}
                            currentPage={currentPage}
                            totalPages={Math.ceil((data?.count || 0) / 10)}
                            onPageChange={handlePageChange}
                        />
                    )}
                </ComponentCard>
            </div>
        </>
    );
}
